// import React from 'react';
// import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
// import contactImage from '../assets/CImg.png'; // Update with your actual image path

// const ContactForm = () => {
//   return (
//     <div className="flex flex-col md:flex-row-reverse items-center justify-center min-h-screen bg-gray-50 p-4 gap-8">
//       {/* Top (Mobile) or Left (Desktop): Image */}
//       <div className="w-full md:w-1/3 p-4">
//         <img src={contactImage} alt="Contact" className="w-full h-full rounded-lg object-cover border" />
//       </div>

//       {/* Bottom (Mobile) or Left (Desktop): Form */}
//       <div className="w-full md:w-1/3 bg-white p-8 rounded-lg shadow-lg">
//         <h2 className="text-center text-lg font-semibold text-gray-700 mb-6">
//           Fill out the form below and we shall get in touch with you.
//         </h2>
//         <form className="space-y-4">
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Your name"
//               className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <span className="absolute left-3 top-3 text-gray-400">
//               <FaUser />
//             </span>
//           </div>
//           <div className="relative">
//             <input
//               type="email"
//               placeholder="Email Address"
//               className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <span className="absolute left-3 top-3 text-gray-400">
//               <FaEnvelope />
//             </span>
//           </div>
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Mobile No"
//               className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//             />
//             <span className="absolute left-3 top-3 text-gray-400">
//               <FaPhone />
//             </span>
//           </div>
         

//           <div className="relative">
//             <textarea
//               placeholder="Message"
//               className="w-full border border-gray-300 rounded-md pl-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//               rows="4" // adjust this number to control the initial height of the textarea
//             />
//           </div>

//           <div className="flex items-center space-x-2 border border-gray-300 p-1 rounded-md">
//             <input type="checkbox" className="w-4 h-8" />
//             <label className="text-gray-600">I'm not a robot</label>
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] text-white font-medium py-2 rounded-md hover:bg-orange-600 transition duration-200"
//           >
//             SUBMIT
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactForm;

import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import contactImage from '../assets/CImg.png'; // Update with your actual image path

const ContactForm = () => {
  // State to manage form data
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: '',
    notARobot: false,
  });

  // Dummy data
  const dummyData = {
    name: 'John Doe',
    email: 'johndoe@example.com',
    mobile: '1234567890',
    message: 'This is a test message.',
    notARobot: true,
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Use FormData to prepare the form submission
    const data = new FormData();
    data.append('name', formData.name);
    data.append('email', formData.email);
    data.append('mobile', formData.mobile);
    data.append('message', formData.message);
    data.append('notARobot', formData.notARobot);

    // Log form data for debugging
    for (const pair of data.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    // Clear form fields after submission
    setFormData({
      name: '',
      email: '',
      mobile: '',
      message: '',
      notARobot: false,
    });
  };

  return (
    <div className="flex flex-col md:flex-row-reverse items-center justify-center min-h-screen bg-gray-50 p-4 gap-8">
      {/* Top (Mobile) or Left (Desktop): Image */}
      <div className="w-full md:w-1/3 p-4">
        <img src={contactImage} alt="Contact" className="w-full h-full rounded-lg object-cover border" />
      </div>

      {/* Bottom (Mobile) or Left (Desktop): Form */}
      <div className="w-full md:w-1/3 bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-center text-lg font-semibold text-gray-700 mb-6">
          Fill out the form below and we shall get in touch with you.
        </h2>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="relative">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your name"
              className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <span className="absolute left-3 top-3 text-gray-400">
              <FaUser />
            </span>
          </div>
          <div className="relative">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <span className="absolute left-3 top-3 text-gray-400">
              <FaEnvelope />
            </span>
          </div>
          <div className="relative">
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Mobile No"
              className="w-full border border-gray-300 rounded-md pl-10 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
            />
            <span className="absolute left-3 top-3 text-gray-400">
              <FaPhone />
            </span>
          </div>
          <div className="relative">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Message"
              className="w-full border border-gray-300 rounded-md pl-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
              rows="4"
            />
          </div>
          <div className="flex items-center space-x-2 border border-gray-300 p-1 rounded-md">
            <input
              type="checkbox"
              name="notARobot"
              checked={formData.notARobot}
              onChange={handleChange}
              className="w-4 h-8"
            />
            <label className="text-gray-600">I'm not a robot</label>
          </div>
          <button
            type="submit"
            className="w-full bg-[#FF9630] text-white font-medium py-2 rounded-md hover:bg-orange-600 transition duration-200"
          >
            SUBMIT
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
